/* TextBlock - migrated to Tailwind */
import { contentBlockClassName } from '../../ContentBlockStyles';

export const textBlockClassName = `${contentBlockClassName} [&_h2]:text-black [&_h2]:m-0 [&_h2]:mb-5`;
